import React from 'react';
import classnames from 'classnames';
import Isvg from 'react-inlinesvg';
import { Link } from 'react-router-dom';
import NavLink from 'app/components/general/NavLink';
import {
  Collapse, Navbar, Nav, NavItem, Tooltip,
} from 'reactstrap';
import TeammoLogo from 'app/images/logo-white.svg';
import MenuIcon from 'app/images/icons/menu.svg';

import JoinIcon from 'app/images/icons/plus.svg';
import ProfileIcon from 'app/images/icons/person.svg';
import HelpIcon from 'app/images/icons/help.svg';
import OverviewIcon from 'app/images/icons/reports.svg';
import RequestIcon from 'app/images/icons/request.svg';
import DownIcon from 'app/images/icons/down-arrow.svg';
import DotsIcon from 'app/images/icons/dots.svg';
import HomeIcon from 'app/images/icons/home.svg';
import LogoutIcon from 'app/images/icons/logout.svg';
import CrossIcon from 'app/images/icons/cross.svg';
import EventsIcon from 'app/images/icons/events.svg';
import TeamIcon from 'app/images/icons/team.svg';
import TeamsIcon from 'app/images/icons/teams.svg';

interface ITopBarProps {
  actions: any;
  users: any;
  match: any;
  teams: any;
  teamName: string;
  teamId: string;
  clubs: any;
  clubName: string;
  clubId: string;
  anonymous: boolean;
}

interface ITopBarState {
  isOpen: boolean;
  tooltipOpen: boolean;
}
class TopBar extends React.Component<ITopBarProps, ITopBarState> {
  static defaultProps: ITopBarProps = {
    clubs: {},
    users: {},
    teams: {},
    actions: {},
    match: {},
    teamName: '',
    teamId: '',
    anonymous: true,
  };

  state: ITopBarState = {
    isOpen: false,
    tooltipOpen: false,
  };

  toggleTooltip = () => {
    if (!this.props.teams.currentTeam.connectedToAssociation) {
      this.setState((previousState) => ({
        tooltipOpen: !previousState.tooltipOpen,
      }));
    }
  };

  toggleOpen = (): void => {
    this.setState({
      isOpen: true,
    });
    document.body.classList.add('lock-position');
  };

  toggleClose = (): void => {
    this.setState({
      isOpen: false,
    });
    document.body.classList.remove('lock-position');
  };

  renderTeamsSelector = (): React.ReactNode => {
    if (this.props.teamName !== undefined) {
      return (
        <NavLink
          onClick={this.toggleClose}
          className={classnames(
            {
              active: this.props.match.path === '/teams',
            },
            'team-selector-nav-link',
          )}
          to="/teams"
        >
          <div>
            <div className="team-selector-group">
              <span className="team-selector-text">{this.props.teamName}</span>
              <Isvg className="team-selector-icon" src={DotsIcon} />
            </div>
          </div>
        </NavLink>
      );
    }
    return null;
  };

  renderClubsSelector = (): React.ReactNode => {
    if (this.props.clubName !== undefined) {
      return (
        <NavLink
          onClick={this.toggleClose}
          className={classnames(
            {
              active: this.props.match.path === '/clubs',
            },
            'team-selector-nav-link',
          )}
          to="/clubs"
        >
          <div>
            <div className="team-selector-group">
              <span className="team-selector-text">{this.props.clubName}</span>
              <Isvg className="team-selector-icon" src={DotsIcon} />
            </div>
          </div>
        </NavLink>
      );
    }
    return null;
  };

  render(): React.ReactNode {
    return (
      <Navbar className="top-bar sticky-top">
        <Link className="navbar-brand" to="/dashboard">
          <Isvg className="header-logo" alt="Teammo" src={TeammoLogo} />
        </Link>
        <button
          onClick={this.toggleOpen}
          type="button"
          className="navbar-toggler navbar-toggler-right"
        >
          <span className="navbar-toggler-icon">
            <Isvg className="menu-icon" alt="Menu" src={MenuIcon} />
          </span>
        </button>
        <div className={classnames('navbar-collapse', 'collapse', {
          show: this.state.isOpen,
        })}
        >
          {/* <Collapse isOpen={this.state.isOpen} navbar> */}
          <Nav className="" navbar>
            <div className="nav-top">
              {this.props.anonymous && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active:
                        this.props.match.path === '/:teamCode/join-team'
                        || this.props.match.path === '/:teamCode',
                    })}
                    to="/"
                  >
                    <Isvg className="nav-link-icon" src={JoinIcon} />
                    <span className="nav-link-text">Join Team</span>
                  </NavLink>
                </NavItem>
              )}
              {!this.props.anonymous && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active:
                        this.props.match.path === '/:teamCode/:teamMemberCode/overview'
                        || this.props.match.path === '/:teamCode/:teamMemberCode',
                    })}
                    to="/"
                  >
                    <Isvg className="nav-link-icon" src={OverviewIcon} />
                    <span className="nav-link-text">Team Overview</span>
                  </NavLink>
                </NavItem>
              )}
              {/* {!this.props.anonymous && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active:
                        this.props.match.path === '/:teamCode/:teamMemberCode/your-details',
                    })}
                    to="/"
                  >
                    <Isvg className="nav-link-icon" src={ProfileIcon} />
                    <span className="nav-link-text">Your Details</span>
                  </NavLink>
                </NavItem>
              )} */}
              {/* {!this.props.anonymous && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active:
                        this.props.match.path === '/:teamCode/:teamMemberCode/payment-history',
                    })}
                    to="/"
                  >
                    <Isvg className="nav-link-icon" src={RequestIcon} />
                    <span className="nav-link-text">Payment History</span>
                  </NavLink>
                </NavItem>
              )} */}
            </div>
            <div className="nav-bottom">
              <NavItem>
                <a
                  className="nav-link"
                  href="https://help.teammo.com.au/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Isvg className="nav-link-icon" src={HelpIcon} />
                  <span className="nav-link-text">Help & Support</span>
                </a>
              </NavItem>
            </div>
          </Nav>
          <div onClick={this.toggleClose} className="navbar-collapse-spacer">
            <button type="button" className="nav-menu-close" onClick={this.toggleClose}>
              <Isvg
                className="nav-menu-close-icon"
                alt="Close"
                src={CrossIcon}
              />
            </button>
          </div>
        </div>
        {/* </Collapse> */}
      </Navbar>
    );
  }
}
export default TopBar;
